import React from 'react'
import PropTypes from 'prop-types'

import Role from '../Role/Role'

import { ROLES } from '../../constants'

import styles from './MemberName.css'

const propTypes = {
    name: PropTypes.string.isRequired,
    tooltipId: PropTypes.string,
    role: PropTypes.oneOf(ROLES),
    roleTooltipId: PropTypes.string,
}

class MemberName extends React.PureComponent {
    render() {
        const role = this.props.role ? (
            <div className={styles.role}>
                <Role role={this.props.role} tooltipId={this.props.roleTooltipId} />
            </div>
        ) : null

        const nameDataAttrs = this.props.tooltipId ? {
            'data-tip': true,
            'data-for': this.props.tooltipId,
        } : {}

        return (
            <div className={styles.base}>
                {role}
                <span className={styles.name} {...nameDataAttrs}>{this.props.name}</span>
            </div>
        )
    }
}

MemberName.propTypes = propTypes

export default MemberName



// WEBPACK FOOTER //
// ../node_modules/react-wot-bootstrap/lib/components/MemberName/MemberName.jsx